module.exports = __webpack_public_path__ + "img/success.c0e48f88.png";